webpackJsonp([35783957827783],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  query {\n      allInventories {\n          id\n          year\n          make\n          model\n          mileage\n          stockNo\n      }\n  }\n'], ['\n  query {\n      allInventories {\n          id\n          year\n          make\n          model\n          mileage\n          stockNo\n      }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    subscription  {\n        Inventory {\n            mutation # contains CREATED, UPDATED or DELETED\n            node {\n                id\n                year\n                make\n                model\n                mileage\n                stockNo\n            }\n        }\n    }  \n  \n'], ['\n    subscription  {\n        Inventory {\n            mutation # contains CREATED, UPDATED or DELETED\n            node {\n                id\n                year\n                make\n                model\n                mileage\n                stockNo\n            }\n        }\n    }  \n  \n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _graphqlTag = __webpack_require__("./node_modules/graphql-tag/lib/graphql-tag.umd.js");
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _reactApollo = __webpack_require__("./node_modules/react-apollo/react-apollo.browser.umd.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var query = (0, _graphqlTag2.default)(_templateObject);
	
	var inventorySubscription = (0, _graphqlTag2.default)(_templateObject2);
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    this.props.subscribeToInventory();
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        client = _props.client;
	
	    console.log('ppprops', this.props, data.allInventories);
	    console.log('client', client.reduxRootKey, client.store.getState());
	    return _react2.default.createElement(
	      'div',
	      null,
	      typeof data.allInventories === 'undefined' ? _react2.default.createElement(
	        'div',
	        null,
	        'Loading...'
	      ) : _react2.default.createElement(Vehicles, { vehicles: data.allInventories })
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	var Vehicles = function Vehicles(_ref) {
	  var vehicles = _ref.vehicles;
	  return _react2.default.createElement(
	    'div',
	    null,
	    vehicles.map(function (vehicle) {
	      return _react2.default.createElement(VehicleCard, { key: vehicle.id, vehicle: vehicle });
	    })
	  );
	};
	
	var VehicleCard = function VehicleCard(_ref2) {
	  var vehicle = _ref2.vehicle;
	  return _react2.default.createElement(
	    'div',
	    { style: { width: '400px', padding: '2em 1em' } },
	    _react2.default.createElement('img', { src: 'http://www.wheelkinetics.com/ebay/' + vehicle.stockNo + '/image1.jpg', style: { float: 'left', width: '100px', height: 'auto', paddingRight: '1em' } }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        HtmlLink,
	        { link: vehicle.make + '-' + vehicle.stockNo },
	        vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      vehicle.mileage,
	      ' mi'
	    )
	  );
	};
	
	var HtmlLink = function HtmlLink(_ref3) {
	  var link = _ref3.link,
	      children = _ref3.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' + link + '/' },
	      children
	    )
	  );
	};
	
	var apolloOptions = {
	  options: {
	    fetchPolicy: 'cache-and-network'
	  },
	  props: function props(_props2) {
	    return {
	      data: _props2.data,
	      subscribeToInventory: function subscribeToInventory(params) {
	        // console.log('p', props);
	        return _props2.data.subscribeToMore({
	          document: inventorySubscription,
	          updateQuery: function updateQuery(prev, _ref4) {
	            var subscriptionData = _ref4.subscriptionData;
	
	            // console.log('update query', subscriptionData);
	            if (!subscriptionData.data) {
	              return prev;
	            }
	            var newInventory = subscriptionData.data.Inventory.node;
	            return _extends({}, prev, {
	              entry: {
	                Inventory: [newInventory].concat(prev.entry.comments)
	              }
	            });
	          }
	        });
	      }
	    };
	  }
	};
	exports.default = (0, _reactApollo.withApollo)((0, _reactApollo.graphql)(query, apolloOptions)(IndexPage));
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-61b61f48013556b27c18.js